// extracted by mini-css-extract-plugin
module.exports = {"conflicts":"TentativeConflicts_conflicts__2p93Y"};